import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ModListStationMaster from '../utility/component/modals/modListStationMaster';
import {
  selectCollectionAccountDetails,
  selectSpinnerLoading,
  setCollectionAccountDetails,
  setListStationMasterModalStatus,
  setModPartyMasterHelpStatus,
  setSessionExpired,
  setSpinnerLoading,
} from '../utility/Redux/modal';
import {
  selectPrefix,
  selectStationId,
  selectStationName,
  selectUserCode,
  selectUserType,
  selectWidth,
  selectreportFromDate,
  selectreportToDate,
  setStationID,
  setStationName,
  setreportsFromDate,
  setreportsTodate,
} from '../utility/Redux/profile';
import moment from 'moment';
import { selectToken } from '../utility/Redux/security';
import { useEffect } from 'react';
import { FromToDate } from '../utility/component/fromToDate';
import GeniusReportsDate from '../utility/component/reportDate';
import ModPartyMasterHelp from '../master/partyMasterHelp';
import { paymentrecieptCol } from './columns';
import { FormatNumber2 } from '../utility/component/tools';
import deleteWholeDatabase from '../utility/functions/deleteWholeDatabase';
import HandleIndexedDB from '../utility/functions/indexDbDatabase';
import { CallAPIPromise } from '../routeBilling/menu/dashboard/biiling/modal/comman';
import NewPrintReport from '../utility/component/datagrid/newPrintReport';
import { useReactToPrint } from 'react-to-print';
import ReportDataTable from '../utility/component/datagrid/ReportDataTable';

const PaymentReciptSummary = () => {
  const token = useSelector(selectToken);

  const ReduxStation_id = useSelector(selectStationId);
  const firstDate = useSelector(selectreportFromDate);
  const SecondDate = useSelector(selectreportToDate);
  const userType = useSelector(selectUserType);
  const [accNumber, setAccNumber] = useState('');
  const [list, setList] = useState([]);
  const prefix = useSelector(selectPrefix);
  const windowWidth = useSelector(selectWidth);
  const columns = paymentrecieptCol(windowWidth);
  const [fromDateFocus, setFromDateFocus] = useState(false);
  const [toDateFocus, setToDateFocus] = useState(false);
  const ReduxStationName = useSelector(selectStationName);
  const [fullList, setFullList] = useState([]);
  const [amountPaidCheck, setAmountPaidCheck] = useState(false);
  const [amountRecievedCheck, setAmountRecievedCheck] = useState(false);
  const [bothCheck, setBothCheck] = useState(true);
  const userCode = useSelector(selectUserCode);

  const accountDetails = useSelector(selectCollectionAccountDetails);
  const spinnerLoading = useSelector(selectSpinnerLoading);

  const getAccountData = () => {
    dispatch(setSpinnerLoading('Loading'));
    deleteWholeDatabase('payment_reciept_summary');

    CallAPIPromise(
      `/api/voucherRoute/receiptPaymentSummary`,
      {
        table_prefix: prefix,
        from_date: firstDate,
        to_date: SecondDate,
        account_no: accNumber,
        station_id: ReduxStation_id ? ReduxStation_id : '',
      },
      token,
      dispatch
    )
      .then((res) => {
        if (!res.data.error) {
          const data = res.data.response;
          if (data[0]) {
            let rowList = [];
            let op_bal = 0;
            for (let index = 0; index < data.length; index++) {
              rowList.push({
                ...data[index],
                OP_BALANCE: op_bal,
                balance:
                  op_bal +
                  (data[index].AMOUNT_PAID - data[index].AMOUNT_RECEIVED),
              });
              op_bal =
                op_bal +
                (data[index].AMOUNT_PAID - data[index].AMOUNT_RECEIVED);
            }

            setFullList(rowList);
            setList(rowList);
            const databaseName = 'payment_reciept_summary';
            const storeName = 'Data';

            const dataToSave = rowList;
            HandleIndexedDB({
              databaseName,
              storeName,
              dataToSave,
              callback: () => {
                const storeName = 'Details';
                const dataToSave = [
                  {
                    SID: ReduxStation_id,
                    SNAME: ReduxStationName,
                    FDATE: moment(firstDate).format('YYYY-MM-DD'),
                    TDATE: moment(SecondDate).format('YYYY-MM-DD'),
                    accName: accountDetails.accName,
                    accAddress: '',
                    accMobile: accountDetails.accMobile,
                    accNumber: accountDetails.accNumber,
                    stationId: '',
                    ICODE: 1,
                    USERCODE: userCode,
                  },
                ];
                HandleIndexedDB({
                  databaseName,
                  storeName,
                  dataToSave,
                });
              },
            });
          } else {
            setList([]);
          }
        }
      })
      .catch((e) => {
        if (e.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
        }
        console.log(e);
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  };

  const okButton = () => {
    getAccountData();
  };
const printRef = useRef()
  const dispatch = useDispatch();

  const totalAmtPaid = list.reduce(
    (total, row) => Number(total) + Number(row.AMOUNT_PAID),
    0
  );
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });
  const totalAmtRecievd = list.reduce(
    (total, row) => Number(total) + Number(row.AMOUNT_RECEIVED),
    0
  );

  const tableColumns = columns.map((column) => {
    const amountFields = ['OP_BALANCE', 'AMOUNT_PAID', 'AMOUNT_RECEIVED', 'balance'];

    if (amountFields.includes(column.field)) {
      return { ...column, width: Math.max(Number(column.width) || 0, 130) };
    }

    return column;
  });

  const footerValue = (column) => {
    if (column.field === 'EXPENCE_NAME') return 'TOTAL';
    if (column.field === 'AMOUNT_PAID') return FormatNumber2(totalAmtPaid);
    if (column.field === 'AMOUNT_RECEIVED') return FormatNumber2(totalAmtRecievd);
    return '';
  };

  const userEffectFunc = () => {
    if (userType !== 'USER') {
      dispatch(setStationID(''));
      dispatch(setStationName(''));
    }

    dispatch(
      setCollectionAccountDetails({
        accName: '',
        accAddress: '',
        accMobile: '',
        accNumber: '',
        stationId: '',
      })
    );
  };

  useEffect(() => {
    let db;
    let database = 'payment_reciept_summary';
    const request = indexedDB.open(database);
    request.onsuccess = function (event) {
      // Assign the opened database instance to the db variable
      db = event.target.result;
      if (db.objectStoreNames.length > 0) {
        const transaction = db.transaction(db.objectStoreNames, 'readonly');

        const objectStoreNames = transaction.objectStoreNames;
        db.close();
        const databaseName = 'payment_reciept_summary';
        const storeNamesArray = Array.from(objectStoreNames);
        const storeName = 'Data';
        if (storeNamesArray[0]) {
          HandleIndexedDB({
            databaseName,
            storeName,
            callback: (data) => {
              const storeName = 'Details';
              HandleIndexedDB({
                databaseName,
                storeName,
                callback: (d) => {
                  console.log(d);
                  setFullList(data);
                  setList(data);
                  dispatch(setStationID(d[0].SID));
                  dispatch(setStationName(d[0].SNAME));
                  dispatch(
                    setreportsFromDate(moment(d[0].FDATE).format('YYYY-MM-DD'))
                  );
                  dispatch(
                    setreportsTodate(moment(d[0].TDATE).format('YYYY-MM-DD'))
                  );
                  dispatch(
                    setCollectionAccountDetails({
                      accName: d[0].accName,
                      accAddress: d[0].accAddress,
                      accMobile: d[0].accMobile,
                      accNumber: d[0].accNumber,
                      stationId: d[0].stationId,
                    })
                  );
                },
              });
            },
          });
        } else {
          userEffectFunc();
        }
      } else {
        db.close();
        userEffectFunc();
        const deleteRequest = indexedDB.deleteDatabase(database);

        deleteRequest.onsuccess = function () {
          console.log('Database deleted successfully');
        };

        deleteRequest.onerror = function (event) {
          console.error('Error deleting database:', event.target.error);
        };
        // Delete the database if no object stores are available
      }
    };
  }, []);

  return (
    <div className="p-4 w-full h-full items-center overflow-y-scroll">
      {window.innerWidth <= 500 ? (
        <>
          <div
            style={{
              border: '1px solid #b5b3b3',
            }}
            className="pr-2 py-3 rounded-t-sm  flex items-center "
          >
            <div className="px-1 ">From</div>

            <GeniusReportsDate
              date={firstDate}
              onChange={(e) => {
                dispatch(setreportsFromDate(moment(e).format('YYYY-MM-DD')));
                setFromDateFocus(false);
              }}
              dateFocus={fromDateFocus}
              SetDateFocus={setFromDateFocus}
            />
            <div className="px-1  ">To</div>
            <GeniusReportsDate
              date={SecondDate}
              onChange={(e) => {
                dispatch(setreportsTodate(moment(e).format('YYYY-MM-DD')));
                setToDateFocus(false);
              }}
              dateFocus={toDateFocus}
              SetDateFocus={setToDateFocus}
            />
          </div>
          <div style={{ border: '1px solid #b5b3b3', borderTop: '0px' }}>
            {userType === 'USER' ? (
              <div className="py-2">
                <button
                  onClick={okButton}
                  className="flex items-center rounded-sm ml-2"
                  style={{
                    backgroundColor: '#4C4747',
                    paddingLeft: 30,
                    paddingRight: 30,
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: 'white',
                  }}
                >
                  <div className="flex items-center">Ok</div>
                </button>
              </div>
            ) : (
              <div className="flex  text-[#4B4545] p-2  ">
                <div
                  onClick={() => {
                    if (userType === 'MANAGER' ||userType === 'STORE' ) {
                      dispatch(setListStationMasterModalStatus(true));
                    }
                  }}
                  style={{ fontSize: 13 }}
                  className=" flex whitespace-normal  justify-center items-center hover:cursor-pointer "
                >
                  <div className="flex items-center ">
                    <div>
                      <i
                        className="bi bi-search"
                        style={{ color: '#f44336', fontSize: 15 }}
                      ></i>
                    </div>

                    <span
                      style={{ fontSize: 12, fontWeight: 600 }}
                      className=" text-[#5c5b5b] pl-2 whitespace-nowrap  items-center"
                    >
                      Station ID
                    </span>
                  </div>

                  <div
                    style={{
                      border: '1px dotted #a6a2a2 ',
                      borderRadius: '3px',
                    }}
                    className="flex text-[#a6a2a2]  pl-2 ml-2  "
                  >
                    <input
                      size={'small'}
                      placeholder="All"
                      value={ReduxStation_id ? ReduxStation_id : 'All'}
                      style={{
                        // width: '20%',
                        fontSize: 12,
                        paddingTop: '2px',
                        paddingBottom: '2px',
                        backgroundColor: 'transparent',
                      }}
                      readOnly
                      className=" outline-0 w-6"
                    />

                    <div
                      style={{
                        borderLeft: '1px dotted #a6a2a2 ',
                      }}
                      className="px-2 p-1 w-36 overflow-hidden whitespace-nowrap print:hidden"
                    >
                      {ReduxStationName ? `${ReduxStationName}` : null}
                    </div>
                  </div>
                </div>
                <div>
                  <button
                    onClick={okButton}
                    className="flex items-center rounded-sm ml-2"
                    style={{
                      backgroundColor: '#4C4747',
                      paddingLeft: 30,
                      paddingRight: 30,
                      paddingTop: 4,
                      paddingBottom: 4,
                      color: 'white',
                    }}
                  >
                    <div className="flex items-center">Ok</div>
                  </button>
                </div>
              </div>
            )}
              <button
                  onClick={handlePrint}
                  className="flex items-center rounded-sm ml-2"
                  style={{
                    backgroundColor: '#4C4747',
                    paddingLeft: 30,
                    paddingRight: 30,
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: 'white',
                  }}
                >
                  <div className="flex items-center">Print</div>
                </button>
          </div>
        </>
      ) : (
        <FromToDate
          partyName={true}
          submit={okButton}
          reset={() => {
            dispatch(setreportsFromDate(moment().format('YYYY-MM-DD')));
            dispatch(setreportsTodate(moment().format('YYYY-MM-DD')));
            if (userType === 'MANAGER') {
              dispatch(setStationID(''));
              dispatch(setStationName(''));
            }
            dispatch(
              setCollectionAccountDetails({
                accName: '',
                accAddress: '',
                accMobile: '',
                accNumber: '',
                stationId: '',
              })
            );
            setBothCheck(true);
            setAmountPaidCheck(false);
            setAmountRecievedCheck(false);
          }}
          
          filter={() => {
            return (
              <div className="ml-2 border-r w-full  text-sm flex items-center">
                <button
                  onClick={handlePrint}
                  className="flex items-center rounded-sm ml-2"
                  style={{
                    backgroundColor: '#bad4f9',
                    paddingLeft: 30,
                    paddingRight: 30,
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: 'black',
                  }}
                >
                  <div className="flex items-center">Print</div>
                </button>
                <div className="ml-1 text-black  flex items-center">
                  <input
                    type="checkbox"
                    checked={amountPaidCheck}
                    onChange={(e) => {
                      setAmountPaidCheck(e.target.checked);
                      if (e.target.checked) {
                        setList(fullList.filter((f) => f.AMOUNT_PAID > 0));
                        setBothCheck(false);
                        setAmountRecievedCheck(false);
                      } else {
                        setList(fullList);
                      }
                    }}
                  />
                  <div className="ml-2">Amount Paid</div>
                </div>
                <div className="ml-3 text-black  flex items-center">
                  <input
                    type="checkbox"
                    checked={amountRecievedCheck}
                    onChange={(e) => {
                      setAmountRecievedCheck(e.target.checked);
                      if (e.target.checked) {
                        setList(fullList.filter((f) => f.AMOUNT_RECEIVED > 0));
                        setBothCheck(false);
                        setAmountPaidCheck(false);
                      } else {
                        setList(fullList);
                      }
                    }}
                  />
                  <div className="ml-2">Amount Recived</div>
                </div>
                <div className="ml-3 text-black  flex items-center">
                  <input
                    type="checkbox"
                    checked={bothCheck}
                    onChange={(e) => {
                      setBothCheck(e.target.checked);
                      if (e.target.checked) {
                        setAmountPaidCheck(false);
                        setAmountRecievedCheck(false);
                      }
                      setList(fullList);
                    }}
                  />
                  <div className="ml-2">Both</div>
                </div>
              </div>
            );
          }}
        />
      )}
      <div
        style={{
          height: `calc(100% - 150px)`,
        }}
        className="mt-3 rounded-sm"
      >
        <ReportDataTable
          columns={tableColumns}
          rows={list}
          loading={Boolean(spinnerLoading)}
          getRowKey={(row, index) => row.VOUCHER_NO || index}
          footerValue={footerValue}
          emptyTitle="No records found"
          emptyDescription="Run the summary to view payment receipts."
          maxHeight="100%"
        />
      </div>
      <div
            style={{
              display: "none",
            }}
          > 
      <div ref={printRef}>
      <NewPrintReport
                title={"Payment Reciept Summary"}
                data={list}
                details={[
                  {
                    name: "Station Name",
                    value: ReduxStationName,
                  },
                ]}
                columns={columns}
              
        />
        </div>
        </div>
      <ModListStationMaster
        onRowClick={(p) => {
          dispatch(setStationID(p.row.CODE));
          dispatch(setStationName(p.row.STATION_NAME));
          dispatch(setListStationMasterModalStatus(false));
        }}
      />
      <ModPartyMasterHelp
        SID={ReduxStation_id}
        onRowClick={(e) => {
          setAccNumber(e.row.ACCOUNT_NO);
          dispatch(setModPartyMasterHelpStatus(false));
          dispatch(
            setCollectionAccountDetails({
              accName: e.row.NAME,
              accAddress: '',
              accMobile: e.row.MOBILE,
              accNumber: e.row.ACCOUNT_NO,
              stationId: '',
            })
          );
        }}
        onClose={() => {
          dispatch(setModPartyMasterHelpStatus(false));
        }}
      />
    </div>
  );
};

export default PaymentReciptSummary;
